import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, DimmedIfDisabled, Page, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { addPreset, isDuplicateName, replacePreset } from '~/features/salesTax/presets';
import { useSalesTaxConfig } from '~/hooks/reactQuery/queries/useSalesTaxConfig';
import { useSetDocumentTitle } from '~/hooks/useSetDocumentTitle';
import { useUpdateVendorUiPreference } from '~/hooks/useUpdateUiPreference';
import { useLocaleKeys } from '~/i18n';
import { DisplayModeSection } from './components/DisplayModeSection/DisplayModeSection';
import { EnableToggleCard } from './components/EnableToggleCard/EnableToggleCard';
import { TaxRatesSection } from './components/TaxRatesSection/TaxRatesSection';
export const GetSalesTaxSettingsTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const SalesTaxSettings = ()=>{
    const { t } = useLocaleKeys('pages.salesTaxSettings');
    const { config, setConfig, updateConfig } = useSalesTaxConfig({
        refreshOnHookMount: true
    });
    const { updateUiPreference } = useUpdateVendorUiPreference();
    const { SalesTaxSettingsTID } = useMemo(()=>GetSalesTaxSettingsTID(), []);
    useSetDocumentTitle(t.pageTitle());
    const handleEnableChange = (enabled)=>{
        updateConfig({
            enabled
        });
        if (enabled) updateUiPreference({
            key: 'hideSetUpSalesTaxCallout',
            value: true
        });
    };
    return /*#__PURE__*/ _jsx(Page, {
        testId: SalesTaxSettingsTID.Root(),
        header: /*#__PURE__*/ _jsx(Typography, {
            variant: "h5",
            weight: "normal",
            children: t.pageTitle()
        }),
        skin: "secondary",
        minWidth: "978px",
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 24,
            children: [
                /*#__PURE__*/ _jsx(EnableToggleCard, {
                    enabled: config.enabled,
                    onChange: handleEnableChange
                }),
                /*#__PURE__*/ _jsx(DimmedIfDisabled, {
                    enabled: config.enabled,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 24,
                        children: [
                            /*#__PURE__*/ _jsx(DisplayModeSection, {
                                displayMode: config.displayMode,
                                label: config.label,
                                onDisplayModeChange: (displayMode)=>updateConfig({
                                        displayMode
                                    }),
                                onLabelChange: (label)=>updateConfig({
                                        label
                                    })
                            }),
                            /*#__PURE__*/ _jsx(TaxRatesSection, {
                                presets: config.presets,
                                isNameDuplicate: (name, excludingId)=>isDuplicateName(config.presets, name, excludingId),
                                onSavePreset: (preset)=>{
                                    const exists = config.presets.some((p)=>p.id === preset.id);
                                    setConfig(exists ? replacePreset(config, preset) : addPreset(config, preset));
                                },
                                onMapToQbo: ()=>undefined
                            })
                        ]
                    })
                })
            ]
        })
    });
};
